// extracted by mini-css-extract-plugin
module.exports = {"buttonorlink":"ButtonOrLink-module__buttonorlink___161up"};